import { Dispatch, ThunkAction } from '../../../../../../../types/actions';
import { IGetState } from '../../../../../../../types/types';
import { EHintKey } from '../../../../../hints';
import { setHintCanShow } from '../../../../../hints/effects/setHintCanShow';

export const showHint = (
    show: boolean
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(setHintCanShow(EHintKey.CARD_SCROLL, show));
    };
    return action;
};
